<template>
    <div class="kgr-row">
        <kgr-club-datev-export-provider
            v-slot="datevExportScope"
            :club-id="clubId"
            :callback="onLoadedDatevExports"
        >
            <kgr-job-meta-club-provider
                :club-id="clubId"
                :callback="onLoadedJobMetaClub"
            >
                <kgr-form-scaffold
                    :pending="pending"
                    :with-back-button="false"
                    :with-primary-buttons="false"
                >
                    <kgr-club-datev-exports-form
                        :error="error"
                        :datev-exports="datevExports"
                        :club-id="clubId"
                        :job-meta-club="jobMetaClub"
                        :pending="pending"
                        :start-year="startYear"
                        :invoice-months="invoiceMonths"
                        :invoice-years="invoiceYears"
                        :booking-periods="bookingPeriods"
                        :is-creatable="isCreatable"
                        class="animated fadeIn"
                        @create="createExport($event)"
                        @init="initPolling(datevExportScope.reload)"
                    />
                </kgr-form-scaffold>
            </kgr-job-meta-club-provider>
        </kgr-club-datev-export-provider>
    </div>
</template>

<script>
import ClubDatevExportProvider from '../../../../components/data-provider/ClubDatevExportProvider';
import ClubDatevExportsForm from '../../../../components/datev/ClubDatevExportsForm';
import ClubFinancialAccountingExportRepository from '../../../../js/repository/ClubFinancialAccountingExportRepository';
import Error from '../../../../js/model/Error';
import FormScaffold from '../../../../components/common/form/FormScaffold';
import JobMetaClubProvider from '../../../../components/data-provider/JobMetaClubProvider';
import JobMetaClubRepository from '../../../../js/repository/JobMetaClubRepository';

export default {
    components: {
        'kgr-club-datev-exports-form': ClubDatevExportsForm,
        'kgr-club-datev-export-provider': ClubDatevExportProvider,
        'kgr-job-meta-club-provider': JobMetaClubProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        bookingPeriods: {
            type: Object,
            required: true,
        },
        startYear: {
            type: String,
            required: true,
        },
        invoiceMonths: {
            type: Object,
            required: true,
        },
        invoiceYears: {
            type: Object,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            datevExports: null,
            jobMetaClub: null,
            interval: 5000,
            tick: 5000,
            maxInterval: 60000,
            exportReload: null,
        };
    },
    computed: {
        hasRunningJob() {
            return this.jobMetaClub.length > 0;
        },
    },
    methods: {
        onLoadedDatevExports(datevExports) {
            this.datevExports = datevExports;
        },
        onLoadedJobMetaClub(jobMetaClub) {
            this.jobMetaClub = jobMetaClub;
        },
        createExport(event) {
            this.pending = true;
            ClubFinancialAccountingExportRepository.createDatevExport(
                this.clubId,
                event.month,
                event.year,
                event.start,
                event.end,
            )
                .then((response) => {
                    this.error = new Error();
                    const xIdentifier = response.headers['x-identifier'];
                    if (xIdentifier === undefined) {
                        this.$notify.error('Für den gewählten Leistungsraum gibt es keine zu exportierenden Rechnungspositionen');
                    } else {
                        this.scheduleJobPolling(0);
                        this.$notify.success('Der Export wurde gestartet');
                    }
                    this.pending = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('Der Export konnte nicht gestartet werden');
                    this.pending = false;
                });
        },
        scheduleJobPolling(initialInterval) {
            if (undefined !== initialInterval) {
                this.interval = initialInterval;
            }
            window.setTimeout(this.pollJob, this.interval);
            if (this.interval < this.maxInterval) {
                this.interval += this.tick;
            }
        },
        pollJob() {
            JobMetaClubRepository.findForClubAndDatevExport(this.clubId)
                .then((jobMetaClub) => {
                    this.jobMetaClub = jobMetaClub;
                    if (this.hasRunningJob) {
                        this.scheduleJobPolling();
                    } else {
                        this.exportReload();
                        this.$notify.success('Der Export wurde fertig gestellt und kann heruntergeladen werden');
                    }
                });
        },
        initPolling(exportReload) {
            this.exportReload = exportReload;
            if (this.hasRunningJob) {
                this.scheduleJobPolling();
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
